"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_EffectEvidenceSynthesis_EffectEstimate = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_EffectEvidenceSynthesis_PrecisionEstimate_1 = require("./RTTI_EffectEvidenceSynthesis_PrecisionEstimate");
exports.RTTI_EffectEvidenceSynthesis_EffectEstimate = t.recursion('IEffectEvidenceSynthesis_EffectEstimate', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        description: t.string,
        _description: RTTI_Element_1.RTTI_Element,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        variantState: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        value: RTTI_decimal_1.RTTI_decimal,
        _value: RTTI_Element_1.RTTI_Element,
        unitOfMeasure: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        precisionEstimate: t.array(RTTI_EffectEvidenceSynthesis_PrecisionEstimate_1.RTTI_EffectEvidenceSynthesis_PrecisionEstimate)
    });
});
//# sourceMappingURL=RTTI_EffectEvidenceSynthesis_EffectEstimate.js.map